import { DIALOG_DATA, DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild, signal } from '@angular/core';
import { DialogDirective } from './dialog.directive';
import { DialogProps } from './dialog.service';
@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [CommonModule, DialogDirective, DialogModule],
  templateUrl: './dialog.component.html',
})
export class DialogComponent {
  @ViewChild(DialogDirective, { static: true }) dialogDirective: DialogDirective | undefined;

  hasBackdrop = signal<boolean>(true);

  constructor(@Inject(DIALOG_DATA) private data: DialogProps) {}

  ngOnInit() {
    if (this.dialogDirective) {
      const viewContainerRef = this.dialogDirective.viewContainerRef;
      const componentRef = viewContainerRef.createComponent(this.data.component);

      if (this.data.componentProps) {
        Object.entries(this.data.componentProps).map(([key, value]) => {
          componentRef.setInput(key, value);
        });
      }
    }

    if (this.data.hasBackdrop === false) {
      this.hasBackdrop.set(false);
    }
  }
}
